import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'x',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-x wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M5.996 4.582a.5.5 0 0 0-.717-.003l-.7.7a.504.504 0 0 0 .003.717L10.586 12l-6.004 6.004a.5.5 0 0 0-.003.717l.7.7c.197.197.514.2.717-.003L12 13.414l6.004 6.004a.5.5 0 0 0 .717.003l.7-.7a.504.504 0 0 0-.003-.717L13.414 12l6.004-6.004a.5.5 0 0 0 .003-.717l-.7-.7a.504.504 0 0 0-.717.003L12 10.586 5.996 4.582z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-x.svg',
    category: 'Core',
    tags: ['close', 'exit', 'X'],
};
export default icon;
